var _g, _line, _polygon, _g2, _g3, _line2, _polygon2, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZkootielogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "125.893px",
    height: "39.186px",
    viewBox: "0 0 125.893 39.186",
    enableBackground: "new 0 0 125.893 39.186",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M18.7,25.138v3.696H1.564v-2.94L12.316,12.93H1.788V9.234H18.28 v2.939L7.556,25.138H18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M27.771,22.926l-2.1,2.072v3.836h-4.368V8.058h4.368v11.761 l6.384-6.049h5.208l-6.272,6.385l6.832,8.68h-5.292L27.771,22.926z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    x1: 56.347,
    y1: 3.996,
    x2: 10.347,
    y2: 3.996
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    points: "12.347,7.304 2.211,3.997 12.347,0.689 "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M98.173,28.605c-0.43,0.318-0.957,0.556-1.582,0.714 c-0.627,0.159-1.285,0.238-1.975,0.238c-1.793,0-3.178-0.458-4.158-1.372s-1.471-2.258-1.471-4.032v-6.188h-2.324v-3.36h2.324 v-3.668h4.369v3.668h3.752v3.36h-3.752v6.132c0,0.635,0.162,1.125,0.49,1.47c0.326,0.346,0.787,0.519,1.385,0.519 c0.691,0,1.279-0.188,1.764-0.561L98.173,28.605z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M100.86,11.47c-0.504-0.467-0.756-1.045-0.756-1.736 c0-0.69,0.252-1.269,0.756-1.736c0.504-0.466,1.156-0.7,1.959-0.7s1.457,0.224,1.961,0.672c0.504,0.448,0.756,1.008,0.756,1.68 c0,0.728-0.252,1.33-0.756,1.806s-1.158,0.714-1.961,0.714S101.364,11.937,100.86,11.47z M100.636,14.27h4.367v15.064h-4.367V14.27 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M123.735,23.034h-11.396c0.205,0.933,0.691,1.67,1.457,2.212 c0.766,0.541,1.717,0.812,2.855,0.812c0.783,0,1.479-0.116,2.086-0.351c0.605-0.232,1.172-0.602,1.693-1.105l2.324,2.52 c-1.418,1.625-3.49,2.437-6.215,2.437c-1.699,0-3.203-0.331-4.508-0.994c-1.309-0.663-2.316-1.582-3.025-2.758 c-0.709-1.177-1.063-2.511-1.063-4.004c0-1.474,0.35-2.804,1.049-3.99c0.701-1.185,1.662-2.109,2.885-2.772s2.59-0.994,4.102-0.994 c1.475,0,2.809,0.318,4.004,0.952c1.195,0.635,2.133,1.545,2.814,2.73c0.682,1.186,1.021,2.562,1.021,4.13 C123.819,21.914,123.792,22.306,123.735,23.034z M113.515,18.189c-0.672,0.56-1.082,1.326-1.23,2.296h7.42 c-0.15-0.952-0.561-1.712-1.232-2.282s-1.494-0.854-2.465-0.854C115.019,17.35,114.187,17.629,113.515,18.189z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M69.965,12.879c-0.848-2.034-2.074-3.865-3.59-5.403 s-3.32-2.783-5.324-3.644s-4.207-1.336-6.52-1.336s-4.516,0.476-6.52,1.336s-3.809,2.105-5.324,3.644s-2.742,3.37-3.59,5.403 c-0.848,2.034-1.316,4.27-1.316,6.617s0.469,4.583,1.316,6.617c0.848,2.033,2.074,3.865,3.59,5.403s3.32,2.783,5.324,3.644 s4.207,1.336,6.52,1.336s4.516-0.476,6.52-1.336s3.809-2.105,5.324-3.644s2.742-3.37,3.59-5.403 c0.848-2.034,1.316-4.27,1.316-6.617S70.813,14.913,69.965,12.879z M66.106,24.459c-0.636,1.525-1.556,2.898-2.692,4.053 c-1.137,1.153-2.49,2.087-3.993,2.732s-3.155,1.002-4.89,1.002s-3.387-0.356-4.891-1.002c-1.502-0.646-2.855-1.579-3.992-2.732 c-1.137-1.154-2.057-2.527-2.693-4.053c-0.635-1.525-0.986-3.203-0.986-4.963s0.352-3.438,0.986-4.963 c0.637-1.525,1.557-2.899,2.693-4.053c1.137-1.153,2.49-2.087,3.992-2.732c1.504-0.646,3.156-1.002,4.891-1.002 s3.387,0.356,4.89,1.002s2.856,1.579,3.993,2.732c1.137,1.154,2.057,2.527,2.692,4.053s0.987,3.203,0.987,4.963 S66.742,22.934,66.106,24.459z"
  })))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    x1: 66.347,
    y1: 34.996,
    x2: 114.347,
    y2: 34.996
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    points: "114.146,31.882 124.28,35.189 114.146,38.496 "
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M83.395,13.072c-0.848-2.033-2.074-3.865-3.59-5.403 s-3.32-2.783-5.324-3.644s-4.207-1.336-6.52-1.336s-4.516,0.476-6.52,1.336s-3.809,2.105-5.324,3.644s-2.742,3.37-3.59,5.403 c-0.848,2.034-1.316,4.27-1.316,6.617s0.469,4.583,1.316,6.617c0.848,2.033,2.074,3.865,3.59,5.403s3.32,2.783,5.324,3.644 s4.207,1.336,6.52,1.336s4.516-0.476,6.52-1.336s3.809-2.105,5.324-3.644s2.742-3.37,3.59-5.403 c0.848-2.034,1.316-4.27,1.316-6.617S84.242,15.106,83.395,13.072z M79.537,24.652c-0.637,1.525-1.557,2.898-2.693,4.053 c-1.137,1.153-2.49,2.087-3.992,2.732c-1.504,0.646-3.156,1.002-4.891,1.002s-3.387-0.356-4.89-1.002s-2.856-1.579-3.993-2.732 c-1.137-1.154-2.057-2.527-2.692-4.053s-0.987-3.203-0.987-4.963s0.352-3.438,0.987-4.963s1.556-2.898,2.692-4.053 c1.137-1.153,2.49-2.087,3.993-2.732s3.155-1.002,4.89-1.002s3.387,0.356,4.891,1.002c1.502,0.646,2.855,1.579,3.992,2.732 c1.137,1.154,2.057,2.527,2.693,4.053c0.635,1.525,0.986,3.203,0.986,4.963S80.172,23.127,79.537,24.652z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZkootielogo);
export default __webpack_public_path__ + "static/media/zkootielogo.26ff4bbc805612147fcba3797cc0b4f2.svg";
export { ForwardRef as ReactComponent };